$('.custom--form--front textarea').on('input', function () {
    this.style.height = 'auto';

    this.style.height =
        (this.scrollHeight) + 'px';
});



$(document).ready(function(){
  // Add class .warning if input is empty when unfocusing an input or removes it if not empty
  $( ".custom--form--front input[required], .custom--form--front textarea[required], .custom--form--front select[required]" ).blur(function() {
    if( !$(this).val() ) {
        $(this).addClass( "warning" );
        $(this).siblings('label').addClass( "warning" );
    } else {
      $(this).removeClass( "warning" );
      $(this).siblings('label').removeClass( "warning" );
    }
  });

  var requiredCheckboxes = $('.checkboxes :checkbox[required]');
  requiredCheckboxes.change(function(){
    if(requiredCheckboxes.is(':checked')) {
        requiredCheckboxes.removeAttr('required');
    } else {
        requiredCheckboxes.attr('required', 'required');
    }
  });
})



function basicValidation(){
    // Add class .warning if input is empty on load
    $( ".custom--form--front input[required], .custom--form--front textarea[required], .custom--form--front select[required]" ).each(function() {
      if( !$(this).val() ) {
        $(this).addClass( "warning" );
        $(this).siblings('label').addClass( "warning" );
      } else {
        $(this).removeClass( "warning" );
        $(this).siblings('label').removeClass( "warning" );
      }
    });

    var checkRadio = document.querySelector('input[type="radio"]:checked');
    if(checkRadio != null) {
        $('.support_thema').removeClass( "warning" );
        $('.radio_required').removeClass( "warning" );
    } else {
        $('.support_thema').addClass( "warning" );
        $('.radio_required').addClass( "warning" );
    }

    if ($('.checkboxes :checkbox').attr( 'required' ) == 'required') {
      $('.checkboxes').addClass( "warning" );
    } else {
      $('.checkboxes').removeClass( "warning" );
    }
    
  }

  $( ".custom--form--front input[type='submit']" ).click(function() {
    basicValidation();
  })






  document.addEventListener("DOMContentLoaded", function() {
    if (!document.getElementById("offerte-form")) return;


    var domainInput = document.getElementById("domain");
    var domainGiven = document.querySelectorAll(".conditional.domain-given");
    var domainNotGiven = document.querySelectorAll(".conditional.domain-not-given");
  
    function updateConditionalFields() {
      if (domainInput.value.trim() !== "") {
        // Wenn Domain angegeben wurde, anzeigen und das "nicht angegeben"-Element verstecken
        domainGiven.forEach(function(el) {
          el.style.display = "block";
        });
        domainNotGiven.forEach(function(el) {
          el.style.display = "none";
        });
      } else {
        // Wenn keine Domain eingegeben ist, verbergen und das "nicht angegeben"-Element anzeigen
        domainGiven.forEach(function(el) {
          el.style.display = "none";
        });
        domainNotGiven.forEach(function(el) {
          el.style.display = "block";
        });
      }
    }
  
    // Event-Listener, um bei jeder Änderung im Domain-Feld die Logik zu triggern
    domainInput.addEventListener("input", updateConditionalFields);
    domainInput.addEventListener("blur", updateConditionalFields);
  
    // Initiale Überprüfung beim Laden der Seite
    updateConditionalFields();




    function setupConditionalCheckbox(checkboxId) {
      var checkbox = document.getElementById(checkboxId);
      if (!checkbox) return;
      // Annahme: Der Container mit der Klasse "conditional--check" befindet sich im nächsten Block innerhalb desselben übergeordneten Elements
      var container = checkbox.closest(".checkboxes").querySelector(".conditional--check");
      if (!container) return;
      
      function toggle() {
        container.style.display = checkbox.checked ? "block" : "none";
      }
      
      checkbox.addEventListener("change", toggle);
      // Initialer Check
      toggle();
    }
  
    setupConditionalCheckbox("funktion_sonstige");
    setupConditionalCheckbox("grund_sonstiges");
    setupConditionalCheckbox("erfolg_sonstiges");


    (function() {
      var elRangeContainers = document.querySelectorAll(".range");
    
      function setProgress(elTarget) {
        var container = elTarget.closest(".range");
        var intRangeBarWidth = container.clientWidth;
        var progressRatio = (elTarget.value - elTarget.min) / (elTarget.max - elTarget.min);
        var intRangePosition = intRangeBarWidth * progressRatio;
        container.style.background =
          "linear-gradient(to right, var(--track-color-fill) " + intRangePosition + "px, var(--track-color-background) " + intRangePosition + "px)";
    
        // Falls der Container die Klasse "currency" hat, formatiere den Output als CHF, sonst zeige "Wert + ' Monat(e)'" an.
        if (container.classList.contains("currency")) {
          var formattedValue = new Intl.NumberFormat("de-CH", {
            style: "currency",
            currency: "CHF",
            maximumFractionDigits: 0
          }).format(Number(elTarget.value));
          elTarget.nextElementSibling.textContent = formattedValue;
        } else {
          elTarget.nextElementSibling.textContent = elTarget.value + " Monat(e)";
        }
      }
    
      elRangeContainers.forEach(function(container) {
        var rangeInput = container.querySelector("input[type='range']");
        // Der Slider startet jetzt mit dem in HTML definierten Wert
        rangeInput.addEventListener("input", function() {
          setProgress(this);
        });
        // Initialer Aufruf, um den Fortschrittsbalken und den Output korrekt zu setzen
        setProgress(rangeInput);
      });
    })();
    
    

    
  });
  
